export default __webpack_public_path__ + "static/SRUS DS400 - Product Specifications & Technical Data-caf19b379a87422ea21f4185d44effc9.pdf";